import { LOADING, GET_ALL_MERCHANTS, GET_SINGLE_MERCHANT } from './types'

const initialState = {
  allMerchants: {},
  merchant: {},
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case GET_ALL_MERCHANTS:
      return {
        ...state,
        isLoading: false,
        allMerchants: action.payload,
      }
    case GET_SINGLE_MERCHANT:
      return {
        ...state,
        isLoading: false,
        merchant: action.payload,
      }
    default:
      return state
  }
}
